module.exports = __webpack_public_path__ + "img/IMG_0577_8_9_FoamcoreMatted.dc1aaff2.jpg";